import React from "react"
import { Banner } from "@shopify/polaris"
import { useTranslation } from "react-i18next"

export const CreatePageErrorBanner = ({
	createPageError,
	isPreviewError = false,
}) => {
	const { t } = useTranslation()

	return (
		<div style={{ marginTop: "2rem" }}>
			<Banner
				title={t(
					isPreviewError
						? "kopy_pages.error_generating_preview"
						: "kopy_pages.error_creating_product_page",
				)}
				status="critical"
			>
				{createPageError === "Theme not compatible" && (
					<p>{t("kopy_pages.error_creating_page")}</p>
				)}

				<p style={{ fontFamily: "monospace" }}>{createPageError}</p>
			</Banner>
		</div>
	)
}
